import { User } from './User'
import { Tree } from './Tree'
import { Company } from './Company'
import { IHandlerOperation } from './HandlerOperation'
import { OperationService } from './OperationService'
import { Appraisal } from './Appraisal'

export class Inventory {
		public _id: string
		public characterization: {
				fuste: {
						type: string
						value: number
				}
				dap_cap: {
						values: Array<any>
						type: string
						average: number
				}
				characterization_code: number
				height: number
				cup_projection: number
				specialValue: boolean
		}
		public identification: number
		public create_date: string
		public conclusion_date: string
		public inventor: User
		public user_creator: User
		public inventorAnswers: Array<Alternatives>
		public tree: Tree
		public status: string
		public company: Company
		public address: {
				street: string
				lat: number
				lng: number
		}
		public checked?: boolean
		public operation: OperationService
		public appraisal: Appraisal
		public handlerOperations: Array<IHandlerOperation>
}

export class InventoryScheduleList {
		public idMongo: string
		public identification: number
		public treeId: number
	public tree_id: string
		public identifier: string
		public address: string
		public lat: number
		public lng: number
		public createDate: string
		public answerOne: string
		public answerTwo: string
		public management: string
		public os: number
		public executor: string
		public schedulingDate: string
		public status
		public media: Array<string>
		public checked: boolean
		public markerIndex?: number
}

export class InventoryDetailsSchedule {
		public idMongo: string
		public identification: number
		public creator: {
				name: string;
				email: string;
				cpf: string;
				telephone: string;
		}
		public address: string
		public locationReference: string
		public lat: number
		public lng: number
		public executor: string
		public status: string
		public inventorAnswers: Array<{
				evaluation: string,
				answers: Array<string>,
				photo: string
		}>
		public treePhoto: string
		public tree: {
				identification: number;
				identifierName: string;
				identifier: string;
				height: string;
				specie: string;
				family: string;
				dapCapType: string;
				dapCap: string;
		}
		public createDate: string
		public os: {
				idMongo: string;
				isAppraisal: boolean
		}
		public cancelRefused: boolean
}

export class InventoryHistory {
		public idMongo: string
		public process: string
		public identifierName: string
		public identifier: string
		public treeId: string
		public createDate: string
		public address: string
		public answerOne: string
		public answerTwo: string
		public specie: string
		public management: string
		public operation: string
		public osa: string
		public oso: string
		public inventorId: string
		public status: string
}

export class ImageGaleryInventory {
		public photo: string
		public evaluation: string
}

export class Alternatives {
		public alternatives: [{
				text: string
		}]
		public screen: string
}

export class InventoryReportArboreal {
		public idMongo: string
		public createDate: string
		public reportEditionDate: string
		public responsibleForEdition: string
		public process: string
		public responsible: {
				idMongo: string;
				name: string;
				crea: string;
		}
		public address: {
				street: string;
				coordenates: string;
				locationCategory: string;
				comments: string;
		}
		public tree: {
				idMongo: string;
				identification: number;
				identifier: string;
				species: string,
				popularName: string,
				family: string,
				source: string,
				specialCategory: string,
				specieId: string,
				totalHeight: string,
				dapCap: string,
				dapCapType: string,
				stemHeight: string,
				woodVolume: string,
				cupProjection: string,
				specialValue: string,
				treeFormat: {
						url: string,
						status: string
				},
				mediaTree: string;
		}
		public handleOperations: Array<{
		idMongo: string,
		operation: string,
				legalFundamentation?: string;
	}>
		public inventorAnswersWithImagens: Array<{
		url: string,
		question: string,
		answer: Array<string>,
		other: {
			question: string,
			answer: string
		}
	}>
	public inventorAnswersNoImagens: Array<{
		url: string,
		question: string,
		answer: Array<string>,
		other: {
			question: string,
			answer: string
		}
	}>
		public hasLegalfundamentation: boolean
		public considerations: string
		public qrCodeImage: string
		public oldReport: string
}

export class EvaluationINV1 {
		public idMongo: string
		public question: string
		public answers: Array<{
				idMongo: string,
				text: string
		}>
}

export class InventoryImport {
		public data: Date = new Date()
		public responsável: string = ''
		public email: string = ''
		public identificador: string
		public endereço: string = ''
		public categoria_do_local: string = ''
		public referência: string
		public latitude: number = 0
		public longitude: number = 0
		public espécie: string = ''
		public altura: number = 0
		public altura_do_caule: number = 0
		public projeção_da_copa: number = 0
		public formato_da_copa: string = ''
		public dap_cap_tipo: string = ''
		public dap_cap_valor: number = 0
		public valor_especial: string = ''
		public foto_da_árvore: string = ''
		public recomendações_de_manejo: string = ''
		public estado_geral: string = ''
		public observações: string
}

export class ImportInventoryError {
		public row: number
		public error: Array<string>
}

export class ImportationOfInventories {
		public id: number
		public date: string
		public amount: number
		public observation: string
}

export class InventoryScheduleMap {
		public idMongo: string
		public identification: number
		public conclusionDate: Date
		public tree: {
			treeIdMongo: string;
			lat: number;
			lng: number;
			street: string;
			treeMediaUrl: string;
		}
		public appraisal: {
			idMongo: string;
			schedulingDate: Date;
			status: string;
		}

}
